import { Loading, No, YES } from '@velocity-exchange/icons';

export type EnableSignlessTradingState =
	| 'NOT_STARTED'
	| 'AWAITING'
	| 'SUCCESS'
	| 'FAILED';

interface EnableSignlessTradingStepCardProps {
	title: string;
	description: string;
	state: EnableSignlessTradingState;
}

export const EnableSignlessTradingStepCard = (
	props: EnableSignlessTradingStepCardProps
) => {
	const Icon =
		props.state === 'NOT_STARTED' ? (
			<YES size={24} color="var(--text-disabled)" />
		) : props.state === 'AWAITING' ? (
			<Loading className="animate-spin" size={24} color="var(--text-default)" />
		) : props.state === 'SUCCESS' ? (
			<YES size={24} color="var(--positive-green)" />
		) : (
			<No size={24} color="var(--negative-red)" />
		);

	return (
		<div className="flex items-center gap-4 rounded-sm border border-stroke-divider bg-input-bg p-4">
			{/** Icon */}
			{Icon}

			{/** Title and Description */}
			<div className="flex flex-col gap-y-sm">
				<span className="typo-label-sm text-text-default">{props.title}</span>
				<span className="typo-body-xs text-text-secondary">
					{props.description}
				</span>
			</div>
		</div>
	);
};
